// Recursively check if prop has no value in object and add that prop to an array.
// Usefull to check form values before submission and create error object

import { typeCheck } from './index';

export const checkNoValueInObj = (obj, ignored = [], shallowCheck = []) => {
  const emptyValues = Object.keys(obj).reduce((acc, key) => {
    const includesDate = key.toLowerCase().includes('date'); // this is a bit of cheat to account for nested objects with start/end date props

    // short circuit evaluation
    if (ignored.includes(key)) return acc;
    if (typeCheck(obj[key]).isObj && shallowCheck.includes(key)) return acc;

    //check integer is 0
    if (typeCheck(obj[key]).isNum && obj[key] === 0) return acc;

    // base cases
    if (typeCheck(obj[key]).isObj && !Object.keys(obj[key]).length) return acc.concat(key);
    if (!typeCheck(obj[key]).isArray && !typeCheck(obj[key]).isObj && !obj[key])
      return acc.concat(includesDate ? 'dates' : key);

    if (typeCheck(obj[key]).isArray && !obj[key].length) return acc.concat(key);
    if (typeCheck(obj[key]).isObj) return acc.concat(checkNoValueInObj(obj[key], ignored));

    return acc;
  }, []);

  const set = new Set(emptyValues); // get rid of duplicates
  return Array.from(set);
};
